export default "__VITE_ASSET__CCO7uhgL__"